<template>
	<AsiCardDetail :icon="icons.meta" :title="$t('ui.terms.metaData')"
	               :show-action-button="!readonly" :action-button-disabled="disabled" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :icon="icons.metaKeywords" :label="$t('ui.terms.metaKeywords')" :value="item.metaKeywords">
			<template v-slot:default v-if="keywords.length > 0">
				<div class="d-flex flex-row flex-wrap ma-n1">
					<AsiChip :icon="icons.metaKeyword" v-for="keyword in keywords" :key="keyword"
					         class="ma-1" small label>
						{{ keyword }}
					</AsiChip>
				</div>
			</template>
		</AsiCardDetailEntry>
		<AsiCardDetailEntryTranslatedValue :icon="icons.metaDescription" :label="$t('ui.terms.metaDescription')" :value="item.metaDescription"/>
		<AsiCardDetailEntry :icon="icons.canonical" :label="$t('ui.terms.canonical')" :value="item.canonical"/>

		<ItemUpdateDialogMetaData v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen" :item="item"
		                           @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from "vue-property-decorator";
	import AsiCardDetail from "../../common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "../../common/AsiCardDetailEntry.vue";
	import AsiChip from "../../common/AsiChip.vue";
	import Icon from "../../../plugins/icons";
	import DialogHandler from "../../common/DialogHandler";
	import StringHelper from "../../../helpers/StringHelper";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";
	import ItemUpdateDialogMetaData from "@/components/item/admin/ItemUpdateDialogMetaData.vue";
	import AsiCardDetailEntryTranslatedValue from "@/components/common/AsiCardDetailEntryTranslatedValue.vue";

	@Component({
		components: {
			AsiCardDetailEntryTranslatedValue,
			ItemUpdateDialogMetaData, AsiChip, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class ItemCardMeta extends Vue {
		@Prop({type: Object, required: true})
		public item!: IItemAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		@Prop({type: Boolean, default: false})
		public disabled!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		private get keywords(): string[] {
			if (this.item.metaKeywords === null || StringHelper.isEmpty(this.item.metaKeywords)) {
				return [];
			}

			return this.item.metaKeywords
				.split(/\s*[,;]\s*/)
				.filter(w => !StringHelper.isEmpty(w))
				.map(w => w.trim());
		}

		@Emit('change')
		public change(): void {
			return;
		}
	}
</script>

<style lang="scss" scoped>

</style>
